import { makeStyles } from '@material-ui/styles'

let btn_default = {
    backgroundColor: '#F5B01B',
    fontFamily: 'GoBoldThin',
    fontSize: 16,
    textTransform: 'uppercase',
    color: '#000000',
    '&:hover':{
        backgroundColor: '#DD9F21'
    },
    width: "100%",
    padding: "1px 2px",
    minWidth: 40,
    borderRadius: '4px'

}

export const buttonStyles = makeStyles({
    tab: {
      ...btn_default,
        backgroundColor: '#444444',
        color: '#EEEEEE',
        border: '1px solid #0000001F',
        letterSpacing: '1.8px',
        '&:hover': {
        //backgroundColor: '#EB8023'
            color: '#F6B11A',
            borderColor: '#F6B11A',
            backgroundColor: '#444444',

        },
        '&:disabled': {
            backgroundColor: '#E5E5E5',
            color: '#ADADAD',
            cursor: 'not-allowed',
            borderColor: '#E5E5E5',
            'pointer-events': 'auto',
            '&:hover': {
                backgroundColor: '#E5E5E5',
            }
        }
    },
    tab_data: {
        ...btn_default,
        width: "180px",
        backgroundColor: "#F6B11A",
        color: '#ffffff',
        letterSpacing: '1.8px',
        border: '1px solid #F6B11A',
        '&:hover': {
            backgroundColor: '#DD9F21',
        }

    },
    tab_data_grid:{
        textAlign: "end"
    },
    tab_selected:{
        //backgroundColor: "#EB8023"
        color: '#F6B11A',
        borderColor: '#F6B11A',
        backgroundColor: '#444444',
        '&:hover': {
            backgroundColor: '#444444',
        }
    },
    create:{
        ...btn_default,        
        width: "180px",
        fontFamily: 'asap-bold',
        color: '#ffffff'
    },
    add:{
        ...btn_default,
        width: 50,
        marginBottom: 8,
        padding: '3px 2px'
    },
    addForm:{
      ...btn_default,
      width: 120,
        padding: "3px",
        backgroundColor: "#059AE8",
        fontFamily: 'asap-bold',
        color: '#ffffff',
        fontSize: '14px',
        border: 'solid 1px #059AE8',

        '&:hover': {
            backgroundColor: '#0089D1',
            borderColor: '#0089D1'
        },
      '&:disabled':{
        backgroundColor: "#acacac",
          color: "#ffffff",
          borderColor: '#acacac',

        '&:hover':{
          cursor: "not-allowed"
        }        
      }
    },
    btnHelp:{
        minHeight:0,
        marginLeft:20,
        backgroundColor:'transparent',
        boxShadow: "none",
        width: 30,
        height: 30,
        '&:hover':{
          backgroundColor:'transparent'
        }
    },
    iconHelp:{
        fontSize: 40,
        color: "#cdcdcd",
        width: "inherit",
        height: "inherit"
    },
    save:{
        ...btn_default,
        padding: "3px",
        backgroundColor: "#F6B11A",
        fontFamily: 'asap-bold',
        color: "#FFFFFF",
        fontSize: '14px',
        border: 'solid 1px #F6B11A',
        '&:hover':{
            backgroundColor: "#DD9F21",
            borderColor: '#DD9F21',
        },
    },
    cancel:{
        ...btn_default,
        padding: "3px",
        backgroundColor: "#ffffff",
        color: "#F6B11A",
        border: 'solid 2px #F6B11A',
        width: '111px',
        fontFamily: 'asap-bold',
        fontSize:'14px',
        '&:hover': {
            // need to be the same to override defaults
            backgroundColor: "#ffffff",
            color: "#F6B11A",
            border: 'solid 2px #F6B11A',
        }
    },
    move: {
      cursor:"n-resize",
      padding: 3,
      width: 'auto',
      height: 'auto'
    },
    addOption:{
      position: 'absolute',
      left: '100%'
    }
  });

  const defaultBoxAbsolute = {
      position: "absolute",
      left: 0,
      top:0,
      right: 0,
      bottom: 0
  }

  const defaultInput = {
      backgroundColor: "#f5f5f5",
      color: "#666666",
      paddingLeft: "3px",
      paddingRight: "3px" 
  }

  export const viewStyles = makeStyles({
      box_settings:{
          ...defaultBoxAbsolute,
          position: "relative",
          height: "660px",
          top: "20px"
      },
      box_view:{
        ...defaultBoxAbsolute        
      },
      leftBox:{
        ...defaultBoxAbsolute,
        right: "40%"
      },
      verticalLine:{
        position: 'relative',
        '&:after': {
          content:'\"\"',
          display: 'block',
          position:'absolute',
          left:'calc(100% + 10px)',
          width: 1,
          top:-15,
          bottom: -40,
          borderLeft: 'rgba(0, 0, 0, 0.14) 1px solid'
        }
      },
      rightBox:{
        ...defaultBoxAbsolute,
        left:"60%"
      },
      devider:{
          position:"absolute",
          left: "60%"
      },
      titleLeft:{
          fontFamily:"Asap-Italic",
          fontSize: 22,
          color:"#666666",
          marginBottom: "20px"
      },
      titleRight:{
        fontFamily:"GoBold",
        fontSize: 16,
        textTransform: 'uppercase',
        color:"#333333",
        textAlign: "center"
      },
      rightDescription:{
        fontFamily: 'Asap-Regular',
        fontSize: 12,
        color: '#666666'
      },
      tmplList:{
        width:"75%"
      },
      templateBox:{
          border: "#cdcdcd 1px solid",
          backgroundColor: "#ffffff",
          padding:"4px",
          '&.selected': {
            backgroundColor: "#ffa500"
          },
          '&:hover':{
            backgroundColor: "#ffa500"
          },
          cursor: "pointer"
      },
      nameInput: {
        ...defaultInput
      },
      bottomBox:{
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0
      },
      selectContainer:{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end'
      },
      selectList:{
        width: 'calc(100% - 60px)'
      },
      listElementsContainer:{
        maxHeight: 320,
        overflowY: "auto",
        paddingRight: 25        
      },
      listRow:{
        fontFamily: 'Asap-Regular',
        fontSize: 14,
        color: '#666666',
        width: '100%',
        '& .MuiInputBase-root': {
          fontFamily: 'Asap-Regular',
          fontSize: 14,
          color: '#666666'
        },
        '& .MuiInputBase-root.Mui-focused':{
          '& .MuiInputBase-input':{
            color: "#f39348"
          }          
        },
        '& .MuiInput-underline.Mui-focused:after':{
          borderBottom: "2px solid #f39348"
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before':{
          borderBottom: "1px solid rgba(0, 0, 0, 0.42)"
        }
      },
      optionFieldTitle:{
        fontFamily: 'Asap-Regular',
        fontSize: 14,
        color: '#666666'
      },      
      switch:{
        '& .MuiSwitch-colorSecondary.Mui-checked':{
          color: '#ec7f00'
        },
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
          backgroundColor: "#f5b01b"
        }
      },
      designBlockTitle:{
        fontFamily: 'Asap-Italic',
        fontWeight:'bold',
        fontSize: 16,
        color: '#666666',        
        marginBottom: 2,
        minHeight: 22
      },
      designBoxRow:{
        margin: '2px 0',
        minHeight: 22
      },
      designFieldTitle:{
        fontFamily: 'Asap-Bold',        
        fontSize: 12,
        minWidth: 170,
        marginRight: 10,
        color: '#666666'
      },
      designRadio:{
        padding: '5px',
        '& .MuiSvgIcon-root, & .MuiSvgIcon-root.MuiSvgIcon-fontSizeSmall':{
          fontSize: 12
        },
        '&.MuiRadio-colorSecondary.Mui-checked':{
          color: '#666666'
        }
      },
      designRadioLabel:{
        '&.MuiFormControlLabel-root':{
          minWidth: 60
        },
        '& .MuiFormControlLabel-label':{
          fontFamily: 'Asap-Regular',
          fontSize: 12,
          color: '#666666'
        }
      },
      designSlider:{        
        '&.MuiSlider-root':{
          width: "45%",
          marginLeft: 5,
          color: '#666666'
        },
        '&.MuiSlider-root::after':{
          position: 'absolute',
          display: "flex",
          left: '100%',
          top: 2,
          bottom: 0,
          width: 18,
          content: '\"+\"',
          alignItems: 'center',
          justifyContent: 'flex-end',
          fontSize: 12
        },
        '&.MuiSlider-root::before':{
          position: 'absolute',
          display: "flex",
          right: '100%',
          top: 0,
          bottom: 3,
          width: 10,
          content: '\"-\"',
          alignItems: 'center',
          justifyContent: 'flex-start'
        },
        '& .MuiSlider-markLabel':{
          fontFamily: 'Asap-Regular',
          fontSize: 10,
          color: '#666666'
        }
      },
      colorPicker:{
        position: "relative"
      },
      fontSize:{
        marginLeft: 20,
        width: 43,
        backgroundColor: "#cdcdcd",
        '& .MuiInputBase-input':{
          fontSize: 14,
          color: '#666666',
          padding: '2px 0 2px 5px',
          backgroundColor: '#ffffff',
          border: '#707070 1px solid',
          height: 19,
          fontFamily: 'Asap-Regular'
        },
        '&.MuiInput-underline:after, &.MuiInput-underline:before':{
          display: 'none'
        }
      },
      fontPicker: {
        width: 150,
        margin: "0 0 0 20px",
        '& .MuiInputBase-input':{
          fontSize: 14,
          color: '#666666',
          padding: '2px 20px 2px 5px',
          backgroundColor: '#f5f5f5'
        },
        '& .MuiInputBase-input.MuiSelect-select': {
          backgroundColor: '#ffffff',
          border: '#707070 1px solid'
        },
        '&.MuiInput-underline:after, &.MuiInput-underline:before':{
          display: 'none'
        }
      },
      previewBox: {
        transform: 'scale(0.8)',
        transformOrigin: '0 0'
      },
      presDropdown:{
        width: "100%",
        '& .MuiInputBase-input':{
          fontSize: 14,
          color: '#666666',
          padding: '2px 20px 2px 5px',
          backgroundColor: '#f5f5f5'
        },
        '& .MuiInputBase-input.MuiSelect-select': {
          backgroundColor: '#ffffff',
          border: '#707070 1px solid'
        },
        '&.MuiInput-underline:after, &.MuiInput-underline:before':{
          display: 'none'
        }
      },
      settingsFieldText:{
        fontFamily: 'Asap-Italic',
        color: '#666666',
        '&>label.MuiFormLabel-root':{
          fontFamily: 'Asap-Bold',
          color: '#666666',
          fontSize: 16,
          transform: 'translate(0, -4px) scale(0.75)'
        },
        '& .MuiInputBase-input':{
          fontFamily: 'Asap-Italic',
          fontSize: 14,
          color: '#666666',
          paddingLeft: 5,
          paddingRight: 5,
          backgroundColor: '#f5f5f5'
        },
        '& .MuiInputBase-input.MuiSelect-select': {
          backgroundColor: '#ffffff',
          border: '#707070 1px solid'
        },
        '& .MuiInput-underline:after, & .MuiInput-underline:before':{
          display: 'none'
        }
      },
      infoIcon: {
        width: 13,
        transform: 'translate(20px, -4px)',
        cursor: 'help'
      },
      svgIcon: {
        stroke: '#333',
        fontSize: 16,
        strokeMiterlimit:10,
        strokeLinecap:'round',
        strokeLinejoin: 'round',
        strokeWidth:'1px',
        fill: '#333',
        '&:hover': {
            stroke: '#f5b01b',
            '& .trash':{
                fill:'#f5b01b',
                stroke: '#f5b01b',
                strokeWidth: '0.3px'
            },
            '& .duplicate':{
                '&.a': {
                    fill:'#f5b01b',
                    stroke: '#f5b01b'                    
                },
                '&.b': {
                    stroke: '#f5b01b'                    
                },
                '&.c': {
                    fill:'#f5b01b'
                }
            }
        },
        '& .edit':{
            fill: 'none'
        },
        '& .duplicate':{
            '&.a': {
                stroke: '#000',
                strokeWidth:'0.119px'
            },
            '&.b': {
                stroke: '#000',
                strokeWidth:'0.747px',
                fill: 'none',
            }
        },
        '& .trash':{
            stroke:'#515151',
            strokeWidth: '0.3px'
          },
        '&.active': {
            stroke: '#f5b01b'
        },
    }
  })